import { csx, cx, Flex } from '@vtex/admin-ui'
import { Item } from 'typings'
import styles from './shippingMethods.css'

interface Props {
  item: Item
  maxWidth?: number
}

export function ItemRenderer(props: Props) {
  const { item, maxWidth } = props

  return (
    <Flex
      className={cx(csx({ maxWidth: maxWidth }), styles.itemContainer)}
      title={item.name}
      data-testid={`multiselect-item-${item.id}`}
    >
      <p className={styles.itemText}>{item.name}</p>
    </Flex>
  )
}
